// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"UX-z","subtitle":"VX-z","wrapper":"WX-z","leftArrow":"XX-z","rightArrow":"YX-z"};